
export default {
  props: {
    type: {
      validator: value => ["prev", "next"].includes(value),
      default: true,
    },
    size: {
      validator: value => ["big", "small"].includes(value),
      default: true,
    },
    /** When true, renders in normal flow (no absolute positioning). */
    inline: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    style() {
      return this.type == "next"
        ? { transform: "rotate(-90deg)" }
        : { transform: "rotate(90deg)" };
    },
  },
};
